/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Client_Merge_HintInputs */

const cs_client_merge_hint = /** @type {(inputs: Client_Merge_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tento klient bude včleněn do jiného. Nelze vrátit.`)
};

const en_client_merge_hint = /** @type {(inputs: Client_Merge_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This client will be folded into another. Cannot be undone.`)
};

/**
* | output |
* | --- |
* | "This client will be folded into another. Cannot be undone." |
*
* @param {Client_Merge_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const client_merge_hint = /** @type {((inputs?: Client_Merge_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Client_Merge_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_client_merge_hint(inputs)
	return cs_client_merge_hint(inputs)
});